import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    tournamentResults: [],
    tournamentResult: {}
  },
  mutations: {
    index(state, payload) {
      state.tournamentResults = payload
    },
    show(state, payload) {
      state.tournamentResult = payload
    }
  },
  actions: {
    index ({commit}) {
      axios.get(`${ENV.API_URL}/api/tournament_results`).then((res) => {
        commit('index', res.data)
      })
    },
    show({commit}, payload) {
      axios.get(`${ENV.API_URL}/api/tournament_results/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({commit}, payload) {
      axios.post(`${ENV.API_URL}/api/tournament_results`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    uptade({commit}, payload) {
      axios.put(`${ENV.API_URL}/api/tournament_results/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    tournamentResults: state => {
      return state.tournamentResults
    },
    tournamentResult: state => {
      return state.tournamentResult
    }
  },
  modules: {
  }
}
